module.exports = __webpack_public_path__ + "img/icon_word.cee97c2a.jpg";